/* istanbul ignore file */

import { Aggregators } from '../../services/logic-services/enums';

export const AGGREGATOR_OPTIONS_CONSTANTS = [
    { text: 'Sum', value: Aggregators.Sum },
    { text: 'Average', value: Aggregators.Average },
    { text: 'Min', value: Aggregators.Min },
    { text: 'Max', value: Aggregators.Max },
    { text: 'Count', value: Aggregators.Count },
];

export const AGGREGATOR_CONSTANTS = {
    SUBROW_AGGREGATE_TOOLTIP: 'This includes the parent and sub-rows.',
    GRID_LEVEL_AGGREGATE_TOOLTIP: 'This includes all parent and sub-rows.',
    COLLAPSED_PARENT_SUM_TOOLTIP: 'Sum of parent and sub-rows:',
    COLLAPSED_PARENT_COUNT_TOOLTIP: 'Count of parent and sub-rows:',
    COLLAPSED_PARENT_MIN_TOOLTIP: 'Minimum of parent and sub-rows:',
    COLLAPSED_PARENT_MAX_TOOLTIP: 'Maximum of parent and sub-rows:',
    COLLAPSED_PARENT_AVERAGE_TOOLTIP: 'Average of parent and sub-rows:',
};
